import { GET_VIDEOS_BY_TERRITORY } from './operations'
import type { PostsQueriesMap } from './types'

export const POSTS_QUERIES: PostsQueriesMap = {
  getVideosByTerritory: GET_VIDEOS_BY_TERRITORY,
}
